// Shared basis type and MEV-component derivation.
//
// The former window-statistics machinery (meanOf, sampleStdDev, summarize,
// drawerStats) served only the [stats] drawer and was removed with it (C57).
//
// Honesty rule: null means unknown. mevComponentPp yields null (never 0)
// unless both inputs are real served values.

/** Which delegator-APY series a computation reads: net (incl. MEV) or base (inflation-only). */
export type StatsBasis = "net" | "base";

/**
 * MEV component = net minus base, same epoch — both real served values.
 * Null-safe: absent (null) if either side is null, never 0. Consumed by
 * the answer band's net-incl-MEV cell and the MEV view (view-options.ts).
 */
export function mevComponentPp(netPct: number | null, basePct: number | null): number | null {
  return netPct !== null && basePct !== null ? netPct - basePct : null;
}
